import { useEffect, useState } from 'react';
import { apiGetPolicyPauseOverviewInfo } from '@jove-frontend/uikit';

type PolicyPauseOverviewInfo = {
  days_left?: number;
  days_used?: number;
  pauses_left?: number;
  pauses_used?: number;
  total_days_per_year?: number;
  total_pauses_per_year?: number;
};

export const usePolicyPauseOverviewInfo = (policyId: string) => {
  const [timeInfoLoading, setTimeInfoLoading] = useState(false);
  const [policyRemaingTimeInfo, setPolicyRemaingTimeInfo] =
    useState<PolicyPauseOverviewInfo>({});

  const requestGetPolicyPauseInfo = async () => {
    setTimeInfoLoading(true);
    const [res] = await apiGetPolicyPauseOverviewInfo({ policyId });
    setTimeInfoLoading(false);
    if (res) {
      setPolicyRemaingTimeInfo(res);
    }
  };
  useEffect(() => {
    requestGetPolicyPauseInfo();
  }, []);

  return {
    timeInfoLoading,
    policyRemaingTimeInfo,
  };
};
